export default __webpack_public_path__ + "static/media/half-circle-white.3187cc35.svg";